import { interfaceConstants } from '../_constants';

export function enseigne(state = {}, action) {
  switch (action.type) { 
     case interfaceConstants.ENSEIGNE_REQUEST:
      return {
        loading: true
      };
    case interfaceConstants.ENSEIGNE_SUCCESS:
      return {
        items: action.enseigne
      };
    case interfaceConstants.ENSEIGNE_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}